import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider, useLanguage } from "@/i18n/LanguageContext";
import { SiteMediaProvider } from "@/context/SiteMedia";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Coaching from "@/pages/Coaching";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 80);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const NotFound = () => {
  const { t } = useLanguage();
  return (
    <section className="py-32 text-center" data-testid="not-found-page">
      <h1 className="font-display uppercase text-4xl sm:text-5xl text-white mb-4">
        {t.notFound.title}
      </h1>
      <p className="text-sm text-bone-soft mb-10">{t.notFound.body}</p>
      <Link
        to="/"
        className="inline-flex px-7 py-4 text-sm font-semibold tracking-wider uppercase bg-gold text-black rounded hover:bg-gold-bright transition-colors"
        data-testid="not-found-home-link"
      >
        {t.notFound.cta}
      </Link>
    </section>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SiteMediaProvider>
          <ScrollManager />
          <div className="min-h-screen bg-coal-base text-bone font-sans antialiased flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/coaching" element={<Coaching />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <ChatWidget />
          <Toaster theme="dark" position="bottom-right" richColors />
        </SiteMediaProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
